<template>
  <div class="container mt-2">
    <div class="btn-toolbar justify-content-between" role="toolbar">
      <button @click="save" id="mailsave" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/>
      <div class="input-group">
        <input type="text" v-model="testmail" placeholder="Emfpänger" class="form-control">
        <div class="input-group-append">
          <button id="mailcheck" @click="testMail" class="btn btn-secondary"><font-awesome-icon icon="vial"/>&nbsp;Testmail</button>
        </div>
      </div>
      <router-link to="/mailtemplates"><button class="btn btn-secondary">E-Mail Vorlagen...</button></router-link>
    </div>
    <div class="row mt-3">
      <div class="col-sm">
        <div class="form-group">
          <label>E-Mail:</label>
          <input type="text" id="mailcontact" v-model="config['proxy.mail.contact']" class="form-control">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label>Mail-Host:</label>
          <input type="text" id="mailhost" v-model="config['proxy.mail.host']" class="form-control">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label>Mail-Port:</label>
          <input type="text" id="mailport" v-model="config['proxy.mail.port']" class="form-control">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-check">
          <input type="checkbox" id="mailssl" v-model="config['proxy.mail.starttls']" true-value="1" false-value="0" class="form-check-input">
          <label for="mailssl">SSL</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-check">
          <input type="checkbox" id="mailtls" v-model="config['proxy.mail.usetls']" true-value="1" false-value="0" class="form-check-input">
          <label for="mailtls">STARTTLS</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label>TLS Protokolle</label>
          <input type="text" class="form-control" v-model="config['proxy.mail.tlsprotocols']"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label>Benutzer:</label>
          <input type="text" id="mailuser" v-model="config['proxy.mail.user']" class="form-control">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label>Passwort:</label>
          <input type="password" id="mailpass" v-model="config['proxy.mail.pass']" class="form-control">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="form-check">
          <input type="checkbox" id="maildebug" v-model="config['proxy.mail.debug']" true-value="1" false-value="0" class="form-check-input">
          <label for="maildebug">Debugging:</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'EmailConfig',
  data() {
    return {
      needs: ["proxy.mail.pass","proxy.mail.usetls","proxy.mail.tlsprotocols","proxy.mail.user","proxy.mail.debug","proxy.mail.starttls","proxy.mail.port","proxy.mail.host","proxy.mail.contact"],
      config: {},
      testmail: "",
    }
  },
  mounted: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    testMail: function() {
      console.log('check mail');
      var mail = this.testmail;
      if (!mail || mail.length == 0) {
        this.$bvToast.toast('Bitte eine Ziel-E-Mail angeben.',{title:'Test Mail',variant:'warning'});
        return;
      }
      var self = this;
      config.get(this,config.baseUrl + 'rest/config/testmail?mail=' + encodeURIComponent(mail),'Test-Mail senden',function() {
        self.$bvToast.toast('E-Mail wurde gesendet.',{title:'Test Mail',variant:'success'});
      })
    },
    save: function() {
      var self = this;
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'E-Mail',variant: 'success'});
      })
    }
  }
}
</script>
